<template>
  <div id="users">
    <portal to="toolbarMenuContent">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </portal>
    <base-material-card color="primary" inline icon="mdi-alert">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Fatturazione
        </div>
      </template>

      <div class="mt-4 ">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td><strong>Inviare fattura</strong> a: yobeesrl@livornopec.it</td>
              <td><strong>Codice destinatario per fattura elettronica:</strong> T9K4ZHO</td>
            </tr>
            <tr>
              <td><strong>Termini di pagamento:</strong> {{ payment_term }}</td>
              <td><strong>Fatturare a:</strong> Yobee Srl, via Giacomo Watt 27, 20143 Milano (MI) - P.I. 01760930493
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <v-data-table
          class="mt-4"
          :headers="table.headers"
          :items="invoices"
          :search.sync="table.search"
          hide-default-footer
          disable-pagination
          disable-sort>
        <template v-slot:item="{ item }">
          <tr v-for="invoice in item.invoices" :key="invoice.id">
            <td> {{ invoice.website }}</td>
            <td> {{ invoice.month }}</td>
            <td> {{ invoice.year }}</td>
            <td> {{ invoice.revenue }}</td>
            <td> {{ invoice.note }}</td>
          </tr>
        </template>
      </v-data-table>

      <v-snackbar
          v-model="snackbar[0].status"
          :timeout="snackbar[0].timeout"
          :color="snackbar[0].type"
      >
        <strong> {{ snackbar[0].text }}</strong>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar[0].status = false">
            Chiudi
          </v-btn>
        </template>
      </v-snackbar>

    </base-material-card>
  </div>
</template>

<script>
export default {
  name: 'Invoices',
  data: () => ({
    breadcrumbs: [
      {
        text: 'Fatturazione',
        disabled: true
      }
    ],
    snackbar: [
      {
        status: false,
        text: 'Tutto ok!',
        timeout: 6000,
        type: 'success'
      }
    ],
    import_invoice: null,
    invoices: [],
    table: {
      search: undefined,
      headers: [
        {
          text: 'Sito',
          sortable: false,
          value: 'website'
        },
        {
          text: 'Mese',
          value: 'month'
        },
        {
          text: 'Anno',
          value: 'year'
        },
        {
          text: 'Revenue',
          value: 'revenue'
        },
        {
          text: 'Note',
          value: 'note'
        }
      ]
    },
    payment_term: null
  }),
  methods: {},
  mounted() {
    axios.get('invoices').then(response => {
      console.log(response.data)
      this.invoices = response.data
      this.payment_term = this.invoices[0].payment_term
    })
  }
}
</script>
